import queryString from 'query-string';
import helper from '@/helper';
import config from '@/configs/config';

const LINE_LOGIN_URI = 'https://access.line.me/oauth2/v2.1/authorize';

export const getRedirectURI = () => {
  const utmQueryString = helper.getUTMQueryStringFromLocalStorage();
  return `${window.location.origin}/auth/line/callback/${utmQueryString ? `?${utmQueryString}` : ''}`;
};

const getLoginUrl = (loginId) => {
  const queryParams = {
    response_type: 'code',
    client_id: config.lineLoginClientId,
    redirect_uri: getRedirectURI(),
    state: loginId,
    scope: 'openid profile',
    bot_prompt: 'aggressive',
  };

  return `${LINE_LOGIN_URI}?${queryString.stringify(queryParams)}`;
};

export default {
  getLoginUrl,
};
